module.exports = __webpack_public_path__ + "static/media/card-report.5912e82e.png";